export default __webpack_public_path__ + "static/avatar_1-c2254bc69bfac415c2f0e4c5e85b608f.svg";